import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

function ViewConvenioDade() {
  console.log("Componente ViewConvenioDade renderizado");
  const [data, setData] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  function formatBRL(value) {
    if (value === null || value === undefined || value === "") return "-";

    let cleaned = value;

    if (typeof value === "string") {
      cleaned = cleaned.trim();
      cleaned = cleaned.replace("R$", ""); // tira o "R$"
      cleaned = cleaned.replace(/\./g, ""); // tira os pontos (milhar)
      cleaned = cleaned.replace(/,/g, "."); // troca vírgula por ponto (decimal)
      cleaned = cleaned.trim(); // tira espaços depois
    }

    const num = Number(cleaned);

    if (isNaN(num)) {
      console.log("Valor inválido para formatação:", value);
      return "-";
    }

    return num.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
  }

  const carregarDados = () => {
    axios
      .get("/api/conveniosdade")
      .then((res) => {
        console.log("Resposta API:", res.data);
        setData(res.data);
      })
      .catch((err) => {
        console.error("Erro no axios:", err);
        alert("Erro ao carregar dados do servidor");
      });
  };

  useEffect(() => {
    const userRole = localStorage.getItem("UserRole");
    setIsAdmin(userRole === "admin");
    carregarDados();
  }, []);

  const handleDelete = (id) => {
    if (window.confirm("Tem certeza que deseja deletar este lançamento?")) {
      axios
        .delete(`/api/conveniosdade/${id}`)
        .then((res) => {
          if (res.data.message === "Convenio deletado com sucesso!") {
            alert("Convênio deletado com sucesso!");
            carregarDados();
          } else {
            alert("Erro ao deletar o lançamento");
          }
        })
        .catch((err) => {
          console.error(err);
          alert("Erro no servidor");
        });
    }
  };

  return (
    <div className="fs-11 px-18 py-8" style={{ overflow: "visible" }}>
      <div className="d-flex justify-content-center mb-3">
        <h3>Convênios DADE</h3>
      </div>

      <div className="mb-3 d-flex align-items-center gap-2 flex-wrap">
        {isAdmin && (
          <Link to="/addconvenios_dade" className="btn btn-primary">
            + Novo Convênio
          </Link>
        )}
        <Link to="/conveniosestadual" className="btn btn-secondary">
          Convênio ESTADUAL
        </Link>
        <Link to="/conveniosfederal" className="btn btn-secondary">
          Convênios FEDERAL
        </Link>
        <Link to="/conveniosfinisa" className="btn btn-secondary">
          Convênios FINISA
        </Link>
        <Link to="/conveniossempapel" className="btn btn-secondary">
          Convênios SEM PAPEL
        </Link>

        <input
          type="text"
          placeholder="Buscar por Unidade, Conta, Aplicação..."
          className="form-control"
          style={{ maxWidth: "300px" }}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <div style={{ overflowX: "auto" }}>
        <table className="table table-responsive table-bordered table-hover">
          <thead className="table-primary">
            <tr>
              <th>ID</th>
              <th>Objeto</th>
              <th>Contrato</th>
              <th>Nº Convênio</th>
              <th>Ano</th>
              <th>Repasse (R$)</th>
              <th>Contrapartida (R$)</th>
              <th>Assinatura Termo</th>
              <th>Vigência Convênio</th>
              <th>Vigência Contrato</th>
              <th>Empresa</th>
              <th>OIS</th>
              <th>Fiscal / Contador</th>
              <th>Conta Bancária</th>
              <th>Recurso Liberado</th>
              <th>Status</th>
              {isAdmin && <th>Ações</th>}
            </tr>
          </thead>

          <tbody>
            {data
              .filter((convenios_dade) => {
                const search = searchTerm.toLowerCase();
                return (
                  convenios_dade.objeto?.toLowerCase().includes(search) ||
                  convenios_dade.contrato?.toLowerCase().includes(search) ||
                  convenios_dade.numero_convenio?.toString().includes(search) ||
                  convenios_dade.ano?.toString().includes(search) ||
                  convenios_dade.empresa?.toLowerCase().includes(search) ||
                  convenios_dade.ois?.toLowerCase().includes(search) ||
                  convenios_dade.fiscal_contador
                    ?.toLowerCase()
                    .includes(search) ||
                  convenios_dade.conta_bancaria
                    ?.toLowerCase()
                    .includes(search) ||
                  convenios_dade.status?.toLowerCase().includes(search)
                );
              })
              .map((convenios_dade, index) => (
                <tr key={index}>
                  <td>{convenios_dade.id}</td>
                  <td>{convenios_dade.objeto}</td>
                  <td>{convenios_dade.contrato}</td>
                  <td>{convenios_dade.numero_convenio}</td>
                  <td>{convenios_dade.ano}</td>
                  <td>{formatBRL(convenios_dade.repasse)}</td>
                  <td>{formatBRL(convenios_dade.contrapartida)}</td>
                  <td>{convenios_dade.assinatura_termo}</td>
                  <td>{convenios_dade.vigencia_convenio}</td>
                  <td>{convenios_dade.vigencia_contrato}</td>
                  <td>{convenios_dade.empresa}</td>
                  <td>{convenios_dade.ois}</td>
                  <td>{convenios_dade.fiscal_contador}</td>
                  <td>{convenios_dade.conta_bancaria}</td>
                  <td>{convenios_dade.recurso_liberado}</td>
                  <td>{convenios_dade.status}</td>
                  {isAdmin && (
                    <td>
                      <button
                        className="btn btn-light btn-sm me-2"
                        onClick={() =>
                          navigate(`/editconveniosdade/${convenios_dade.id}`)
                        }
                      >
                        Editar
                      </button>

                      <button
                        className="btn btn-info btn-sm"
                        onClick={() => handleDelete(convenios_dade.id)}
                      >
                        Deletar
                      </button>
                    </td>
                  )}
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ViewConvenioDade;
